import BaseApiService from './api.base.service'
export default class EmailsApiService extends BaseApiService {
  constructor() {
    super('emails')
  }

  getEmails(query, skip = 0, take = 20) {
    if (query) {
      return this.callGet(
        `/unsubscriptions/keys?query=${query}&skip=${skip}&take=${take}`
      )
    }

    return this.callGet(`/unsubscriptions/keys?skip=${skip}&take=${take}`)
  }

  getEmailUnsubscriptions(filter) {
    return this.callPost(`/unsubscriptions/report`, {
      orderBy: filter.orderBy,
      skip: filter.skip,
      take: filter.take,
      email: filter.email,
      startDate: filter.startDate,
      endDate: filter.endDate,
    })
  }

  unsubscribeEmail(email) {
    return this.callPost('/unsubscriptions', {
      email: email,
    })
  }
}

export const emailsApi = new EmailsApiService()
